import { baseUrl } from "util/APIBaseUrl";
import { makeRequest } from "util/APIHelper";

export const updateEmployeePersonalInfo = async (employeeId, body) => {
  const {
    payload: { error },
  } = await makeRequest(
    {
      path: `${baseUrl}/v2/employee/${employeeId}`,
      contentType: "application/json",
      method: "PATCH",
      body: JSON.stringify(body),
    },
    false
  );
  if (error) {
    throw new Error("Profile could not be updated");
  }
};

export const getEmployeeStatus = async (employeeId) => {
  const {
    payload: { data, error },
  } = await makeRequest(
    {
      path: `${baseUrl}/employee/${employeeId}/employee_status`,
      contentType: "application/json",
      method: "GET",
    },
    false
  );
  if (error) {
    throw new Error("Could not fetch employee status");
  }
  return data;
};

export const updateEmployeeStatus = async (employeeId, statusData) => {
  const {
    payload: { error },
  } = await makeRequest(
    {
      path: `${baseUrl}/employee/${employeeId}/employee_status`,
      contentType: "application/json",
      method: "PUT",
      body: JSON.stringify(statusData),
    },
    false
  );
  if (error) {
    const err = new Error("Employee status could not be updated");
    err.response = { data: { error } };
    throw err;
  }
};

export default updateEmployeePersonalInfo;
